import React from "react";
import {
  HeroSection as PageQueryHeroSection,
  StaticPage,
} from "components/StaticPageTemplate/queries";
import HtmlContent from "components/common/HtmlContent";
import SectionHeader from "components/common/SectionHeader";
import styles from "./About.module.css";

type AboutUsPageProps = Omit<PageQueryHeroSection, "__typename"> & {
  content: StaticPage["content"];
};

const AboutUs = ({ title, summary, content }: AboutUsPageProps) => (
  <>
    {title && summary && <SectionHeader color="white" title={title} summary={summary} />}
    {content && (
      <div className={styles.aboutContentWrapper}>
        <HtmlContent className={styles.aboutContent}>{content}</HtmlContent>
      </div>
    )}
  </>
);

export default AboutUs;
